module.exports = __webpack_public_path__ + "img/w3_reload_grey.b55aa7b0.png";